import {REFER_AND_EARN_ENABLED} from '../constant/features';
import React,{useEffect} from "react";
import {
  Grid,
  Card,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import {
  setAccessToken,
  setUser,
  setSessionExpired
} from "../Redux/Reducers/appState";
import { useNavigate } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ListAltIcon from "@mui/icons-material/ListAlt";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PersonIcon from "@mui/icons-material/Person";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import CampaignIcon from "@mui/icons-material/Campaign";
import { API } from "../constant/apiConstant";
import { Colors } from "../utils/colors";
import { useSelector,useDispatch } from "react-redux";
import { AuthService } from "../services/auth/Auth";
import Alert from '@mui/material/Alert';

export default function AuthMenu() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((data) => data.appState.user);
  const sessionExpired = useSelector((state) => state.appState.sessionExpired);
  const [isVerified, setIsVerified] = React.useState(false);
  const [hasInfluencerAccess, setHasInfluencerAccess] = React.useState(false);
  const fullName = [user?.first_name, user?.last_name]
    .map((value) => String(value || "").trim())
    .filter(Boolean)
    .join(" ");

  const menuItems = [
    { label: "Dashboard", icon: <DashboardIcon />, path: "/account/authmenu/account/userdashboard" },
    { label: "My Tickets", icon: <ListAltIcon />, path: "/account/authmenu/account/tickets" },
    { label: "Wallet / Payouts", icon: <AccountBalanceWalletIcon />, path: "/account/authmenu/account/wallets" },
    { label: "Profile & KYC", icon: <PersonIcon />, path: "/account/authmenu/account/profile-kyc" },
    { label: "Contact Admin", icon: <HelpCenterIcon />, path: "/account/authmenu/account/profile-kyc/support" },
    ...(REFER_AND_EARN_ENABLED ? [{ label: "Refer & Earn", icon: <CampaignIcon />, path: "/refer-and-earn" }] : []),
    ...(hasInfluencerAccess ? [{ label: "Influencer Dashboard", icon: <CampaignIcon />, path: "/account/authmenu/account/influencer" }] : []),
  ];

  useEffect(() => {
    let mounted = true;
    const check = async () => {
      try {
        const response = await fetch(`${API.BASE_URL}/api/referrals/me/eligibility`, { credentials: "include" });
        const data = await response.json();
        if (mounted) setHasInfluencerAccess(Boolean(response.ok && data.eligible));
      } catch (_error) { if (mounted) setHasInfluencerAccess(false); }
    };
    check();
    const interval = setInterval(check, 60000);
    return () => { mounted = false; clearInterval(interval); };
  }, []);

  useEffect(() => {

    const fetchVerificationStatus = async () => {

      try {
        const response = await AuthService.getProfile();

        if (response?.message === "Invalid or expired token" || response?.message === "Account is closed. Contact support for assistance.") {
          dispatch(setUser(null));
          dispatch(setSessionExpired(true))
        }

        setIsVerified(response?.is_verified || false);

      } catch (err) {
        console.log("Error loading profile:", err);
      }
    };

    fetchVerificationStatus();

  }, [isVerified]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: Colors.secondary,
        p: { xs: 2, sm: 3 },
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 800 }}>

        
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 1,
            gap: 1
          }}
        >
        

         
            {isVerified
              ? <Alert severity="success">Your profile is verified</Alert>
              : <Alert severity="error">Your profile is not yet verified</Alert>}
        
        </Box> 

        <Typography
          variant="h6"
          fontWeight={600}
          sx={{ mb: 3, color: Colors.accent, textAlign: "center" }}
        >
          Welcome, {fullName || user?.first_name || "User"}
        </Typography>

        <Grid
          container
          spacing={{ xs: 2, sm: 3 }}
          justifyContent="center"
        >
          {menuItems.map((item, index) => (
            <Grid
              item
              key={index}
              xs={6}
              sm={4}
              md={3}
              display="flex"
              justifyContent="center"
            >
              <Card
                onClick={() => sessionExpired ? navigate("/login") : navigate(item.path)}
                sx={{
                  width: { xs: 120, sm: 130, md: 140 },
                  height: { xs: 120, sm: 130, md: 140 },
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                  borderRadius: 2,
                  cursor: "pointer",
                  background: "linear-gradient(180deg, #cfb32c 0%, #798793 100%)",
                  border: "1px solid #0d3c7a",
                  transition: "0.25s",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0px 4px 20px rgba(0,0,0,0.4)",
                  },
                }}
              >
                <IconButton
                  sx={{
                    backgroundColor: "#545c66",
                    color: Colors.text,
                    width: { xs: 48, sm: 56 },
                    height: { xs: 48, sm: 56 },
                    "&:hover": {
                      backgroundColor: "#123b63",
                    },
                  }}
                >
                  {item.icon}
                </IconButton>

                <Typography
                  sx={{
                    color: Colors.text,
                    fontWeight: 600,
                    fontSize: { xs: 12, sm: 14 },
                    textAlign: "center",
                    px: 1,
                    lineHeight: "16px",
                    display: "block",
                    wordWrap: "break-word",
                  }}
                >
                  {item.label}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>

      </Box>
    </Box>
  );
}
